import { t } from '@lingui/core/macro';
import { Select } from '@pocketlaw/tetris';
import { useField, useFormikContext } from 'formik';
import { useEsigningAuthenticationModes } from 'app/domains/esigning/hooks/useEsigningAuthenticationModes';
import { useUnsupportedRecipientValues } from 'app/domains/esigning/hooks/useUnsupportedRecipientValues';
import { getAuthenticationModeTitle } from 'app/domains/esigning/utils';
import { EsigningRecipientType } from 'shared/domains/apollo/generated/types';
import { ErrorMessage } from 'shared/domains/forms/components/ErrorMessage';
import { FieldWrapper } from '../../styled';
const FIELD_NAME = 'authenticationMode';
export function AuthenticationModeSelect() {
    const { authenticationModes } = useEsigningAuthenticationModes();
    const { submitCount } = useFormikContext();
    const { isAuthenticationModeUnsupported } = useUnsupportedRecipientValues();
    const [field, meta] = useField(FIELD_NAME);
    const [type] = useField('type');
    const error = Boolean(meta.error && meta.touched) || Boolean(meta.error && submitCount > 0);
    const disabled = type.value === EsigningRecipientType.Viewer;
    const unsupported = isAuthenticationModeUnsupported({ authenticationMode: field.value });
    if (authenticationModes.length === 0) {
        return null;
    }
    return (<FieldWrapper>
      <Select stretch disabled={disabled} invalid={error} {...field} label={t({
            comment: 'Signing party form field - Signing method',
            message: 'Signing method',
        })} placeholder={t({
            comment: 'Select signing party signing method placeholder label',
            message: 'Select signing method',
        })}>
        {unsupported && field.value && (<option value={field.value} disabled>
            {getAuthenticationModeTitle(field.value)}
          </option>)}
        {authenticationModes.map(({ slug }) => (<option key={slug} value={slug}>
            {getAuthenticationModeTitle(slug)}
          </option>))}
      </Select>
      <ErrorMessage name={FIELD_NAME}/>
    </FieldWrapper>);
}
